module.exports = __webpack_public_path__ + "static/media/no-access.b1632219.png";